import { Box, Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { LLMSetupSectionHeader } from "../LLMSetupSectionHeader";
import { SetupFieldLoader } from "../SetupFieldLoader";
import { BrandListField } from "./BrandListField";
import type { ITrackedBrandNamesProps } from "./types";

export const LLMSetupBrandInput = ({ isLoading = false, ...fieldProps }: ITrackedBrandNamesProps) => (
    <Stack gap="12px">
        <LLMSetupSectionHeader
            title={
                <Text
                    fontVariant="subtitle2"
                    data-automation="llm-setup-brand-label"
                >
                    {translate("llm.setup.modal.brand.label")}
                </Text>
            }
        />
        {isLoading ? (
            <Box
                position="relative"
                height="40px"
            >
                <SetupFieldLoader />
            </Box>
        ) : (
            <BrandListField {...fieldProps} />
        )}
    </Stack>
);
